import { useState } from "react";
import { Col, Form, Nav, Row } from "react-bootstrap";
import StructuresCubageTable from "../CubageData/Structures";
import { StyledNav } from "../OnlineStoreData/styles";
import EngineeringInsource from "./EngineeringInsurance";



function InsuranceData() {
    const [tab, setTab] = useState('engineering');

    return (
        <>
            <Form.Group controlId="formConfiguration">
                <Row className="mb-3">
                    <Col md={8}>
                        <StyledNav
                            variant="tabs"
                            activeKey={tab}
                            onSelect={(selectedKey: string) =>
                                setTab(selectedKey)
                            }
                        >
                            <Nav.Item>
                                <Nav.Link eventKey="engineering">Risco Engenharia</Nav.Link>
                            </Nav.Item>
                        </StyledNav>
                    </Col>
                </Row>

                {tab === 'engineering' && <EngineeringInsource />}
            </Form.Group>
        </>
    );
}

export default InsuranceData;